import { LOCAL_IMAGES } from "./localimages";

export const brandimg = [
    {
        img: LOCAL_IMAGES.skinbanner_icon
    },
    {
        img: LOCAL_IMAGES.skinbanner_icon2
    },
    {
        img: LOCAL_IMAGES.skinbanner_icon3
    },
]
export const argatinbannerdata = [
   
    {
        img: LOCAL_IMAGES.argatinbanner1
    },
    {
        img: LOCAL_IMAGES.argatinbanner2
    },
    
]
export const springh2obannerimg = [
   
    {
        img: LOCAL_IMAGES.spring1
    },
    {
        img: LOCAL_IMAGES.spring2
    },
    {
        img: LOCAL_IMAGES.spring3
    },
    
    
]
export const argatinBrands = [
    // {
    //     img:
    // }
]

export const brandsImg=[
    {
        img: 'https://res.cloudinary.com/dkvmvyvnx/image/upload/v1707109780/banner5_nciu1r_frjne3.png'
    },
    {
        img: 'https://res.cloudinary.com/dkvmvyvnx/image/upload/v1703135831/banner6_ggf5kg.png'
    }
]


export const sellingPlateformData = [
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/8-300x150.png'
    },
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/3-300x150.png'
    },
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/9-300x150.png'
    },
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/5-300x150.png'
    },
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/10-300x150.png'
    },
    {
        img: 'https://argatinkeratin.com/wp-content/uploads/2022/11/14-300x150.png'
    }
]
export const brandslidersdata = [
    {
        img: LOCAL_IMAGES.loveusicon1
    },
    {
        img: LOCAL_IMAGES.loveusicon2
    },
    {
        img: LOCAL_IMAGES.loveusicon3
    },
    {
        img: LOCAL_IMAGES.loveusicon4
    },
    {
        img: LOCAL_IMAGES.loveusicon5
    },

]
export const faqData = [
    {
        question: 'How can I be sure that my order has been sent?',
        ans: 'You will get a confirmation email after you place your order. It will have your order number and an estimate ofwhen it will arrive.'
    },
    {
        question: 'Can I change my order after I have already placed it?',
        ans: 'You can  add new items to an order that has already been placed, but you can always place a new order for the items you want. If you want to take something off your order, please call customer service to cancel it so thatyou can place a new order.'
    },
    {
        question: 'How do I find out where my order is?',
        ans: 'Once your order is shipped, you will get an email with tracking information. It will have the name of the  delivery company and the shipment number or AWB. Their website lets you keep track of your order, or you can email us at info@theprofessionalworld.com'
    },
    {
        question: 'Does it cost anything to ship?',
        ans: 'From time to time, we let you know that shipping is free on all orders over Rs.999. The shipping costs that areshown to you when you check out should be taken as final.'
    }, {
        question: 'Can I pay cash when I arrive?',
        ans: 'Yes, we do offer Cash-On-Delivery for no extra cost.'
    },
    {
        question: 'How long does it take for the order to get to me?',
        ans: 'After getting the order, we ship the goods within two business days. Your package should come between 5 and 7 business days after you place the order. Indian, though, is a big country. Please allow extra time for remote places and weather that you didn&#39;t expect.'
    },
    {
        question: 'How do I get in touch with Skin co and Argatin ?',
        ans: 'You can call us at (+91) 9315 743 367 or email us at enquiry@theprofessionalworld.com'
    },
    {
        question: 'Can you get my product to me faster?',
        ans: 'Call our customer service line if you want us to hurry up your order. We&#39;ll ask our transportation partner about itand let you know what we find out..'
    },
    {
        question: 'Note: This only works for items that have already been paid for.',
    },
]
export const privacyPolicyData = [
    {
        pquestion: 'WHAT DO WE DO WITH YOUR INFORMATION?',
        pans: 'When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address. When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. Email marketing : With your permission, we may send you emails about our store, new products and other updates. '

    },
    //     {
    //         pquestion:'CONSENT',
    //         pans:'You agree to our Privacy Policy by using our website.'

    // },
    {
        pquestion: ' CONSENT',
        pans: 'How do you get my consent? When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no. How do I withdraw my consent? If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at enquiry@theprofessionalworld.com or mailing us at: The Professional Hair Salon & Spa (India) Pvt. Ltd. Plot No-31Okhla Industrial Estate, Phase – 3, South Delhi, New Delhi – 110020 '

    },
    {
        pquestion: 'DISCLOSURE',
        pans: 'We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.'

    },
    {
        pquestion: 'PAYMENT',
        pans: 'We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers. For more insight, you may also want to read terms and conditions of razorpay on https://razorpay.com'

    },
    {
        pquestion: 'WE COLLECT INFORMATION',
        pans: 'We will explain why we need your personal information when we ask for it. Your name, email address, phone number, message and attachments, and any other information you supply when you contact us may be shared with us. We may request your name, company name, address, email address, and phonenumber when you register for an Account.'

    },
    {
        pquestion: 'THIRD-PARTY SERVICES',
        pans: 'In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.  In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.  Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.  Links   When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.'

    },
    {
        question: 'Privacy Policy for Salon-Kart Pvt. Ltd.',
        ans: 'At https://salon-cart.com/privacy is a top priority. This Privacy Policy describeshow SKIN CO.&amp; ARGATIN collects and uses data.Please email us with any Privacy Policy questions.This Privacy Policy applies only to our online activities and covers visitors&#39; SKIN CO. &amp; ARGATIN information. Information acquired offline or through sources other than this website is not covered by this policy.'

    },
    {
        pquestion: 'SECURITY',
        pans: 'To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.'

    },
    {
        pquestion: 'WE COLLECT INFORMATION',
        pans: 'We will explain why we need your personal information when we ask for it. Your name, email address, phone number, message and attachments, and any other information you supply when you contact us may be shared with us. We may request your name, company name, address, email address, and phonenumber when you register for an Account.'

    },
    {
        pquestion: 'Privacy Policy for proSalonCart Pvt. Ltd.',
        pans: 'At https://salon-cart.com/privacy is a top priority. This Privacy Policy describeshow SKIN CO.&amp; ARGATIN collects and uses data.Please email us with any Privacy Policy questions.This Privacy Policy applies only to our online activities and covers visitors&#39; SKIN CO. &amp; ARGATIN information. Information acquired offline or through sources other than this website is not covered by this policy.'

    },
    {
        pquestion: 'KID INFORMATION',
        pans: 'We also prioritize internet safety for kids. We recommend parents andguardians observe, participate in, and/or guide their online activity.SKIN CO &amp; ARGATIN does not knowingly collect Personal IdentifiableInformation from children under 14 .We urge you to contact us immediately ifyou believe your child provided this information on our website. We will workto delete it from our database.'

    },
    {
        pquestion: ' COOKIES',
        pans: 'We use cookies to maintain session of your user. It is not used to personally identify you on other websites..'

    },
    {
        pquestion: ' AGE OF CONSENT',
        pans: ' By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.'

    },
    {
        pquestion: 'CHANGES TO THIS PRIVACY POLICY',
        pans: ' We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it. If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.'

    },
    {
        pquestion: 'QUESTIONS AND CONTACT INFORMATION',
        pans: ' If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at enquiry@theprofessionalworld.com or by mail at The Professional Hair Salon & Spa (India) Pvt. Ltd. Plot No-31 Okhla Industrial Estate, Phase – 3, South Delhi, New Delhi – 110020[Re: Privacy Compliance Officer] [622 Manglam Electronic Market Jaipur Rajasthan India 302001] '

    },

]


export const refundData = [
    {
        question: 'Returns',
        ans: 'We want you to love the products that you buy from us. In case you have concerns related to your purchase, drop us a mail within 5 days of delivery with details at enquiry@theprofessionalworld.com'
    },
    {
        question: 'Refunds ',
        ans: 'Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund. If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within 5 - 7  working days.     '
    },
    {
        question: 'Late or missing refunds ',
        ans: 'If you haven’t received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted.     Next contact your bank. There is often some processing time before a refund is posted.   If you’ve done all of this and you still have not received your refund yet, please contact us at enquiry@theprofessionalworld.com'
    },
    {
        question: 'Sale items ',
        ans: 'Only regular priced items may be refunded, unfortunately sale items cannot be refunded.'
    },
    {
        question: 'Exchanges ',
        ans: 'We only replace items if they are defective or damaged.  If you need to exchange it for the same item, send us an email at enquiry@theprofessionalworld.com and send your item to: 622 Manglam Electronic Market Jaipur Rajasthan India 302001.'
    },
    {
        question: 'Gifts',
        ans: 'If the item was marked as a gift when purchased and shipped directly to you, you’ll receive a gift credit for the value of your return. Once the returned item is received, a gift certificate will be mailed to you. If the item wasn’t marked as a gift when purchased, or the gift giver had the order shipped to themselves to give to you later, we will send a refund to the gift giver and he will find out about your return.'

    },
    {
        question: 'Shipping',
        ans: 'We take 3-7 days to door deliver your custom care. We offer free shipping on all pre-paid orders above Rs 499.To return your product, you should mail your product to: 622 Manglam Electronic Market Jaipur Rajasthan India 302001.You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable. If you receive a refund, the cost of return shipping will be deducted from your refund.     Depending on where you live, the time it may take for your exchanged product to reach you, may vary.   If you are shipping an item over $75, you should consider using a trackable shipping service or purchasing shipping insurance. We don’t guarantee that we will receive your returned item.'


    },


    {
        question: 'In case you received the wrong item.',
        ans: 'Drop us an email at enquiry@theprofessionalworld.com or call us at 9315 743 367 within 5 days of the date of delivery. Our Customer delight team will resolve it at the earliest.'
    },
    {

        question: 'In case you received a damaged item.',
        ans: 'Drop us an email with your order id and the picture of the damaged product at enquiry@theprofessionalworld.com or call at 9315 743 367 within 5 days of the date of delivery. Our customer delight team will help you with your queries and resolve it at the earliest.'
    },
    {
        question: "In case you have concerns related to the product.",
        ans: 'Drop us an email at enquiry@theprofessionalworld.com or call at 9315 743 367. Our customer delight team will help you with your queries and resolve it within 24 hours.'

    },
    {
        question: 'In case you need to cancel your order before it has been dispatched.',
        ans: 'You can cancel an order within 3 hours of placing the order.'
    },
    {
        question: 'In case you need to cancel your order after it has been dispatched.',
        ans: 'You can simply refuse to accept the parcel at the time of delivery as the order will not be returned once delivered.'
    },


    {
        question: 'In case your order is marked delivered but not received by you.',
        ans: 'Drop us an email at enquiry@theprofessionalworld.com or call us at 9315 743 367 within 3 days (72 hours) of the date of delivery. Our Customer delight team will resolve it at the earliest.'
    },
    {
        question: 'Shipping charges on purchase.',
        ans: 'We offer FREE Shipping on all orders above Rs.999, which is notified from time to time. We also offer Cash-On-Delivery at no additional charge. You should consider the shipping rates shown at the time of check-out to be final.'
    }


]

export const photoData = [
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_23.jpg?v=1698912705',
        description: 'Acne',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_25.jpg?v=1698912819',

        description: 'Aging',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_26.jpg?v=1698912863',

        description: 'Dryness',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_42.jpg?v=1698912638',

        description: 'Dullness',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_43.jpg?v=1698912984',

        description: 'Uneven Skintone',
    },

];

export const hairData = [
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_31.jpg?v=1698913104',
        description: 'Hairfall',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_33.jpg?v=1698913206',

        description: 'Frizz',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_47.jpg?v=1698913606',

        description: 'Smoothing',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/Ellipse_48.jpg?v=1698913644',

        description: 'Damage Repair',
    },


];




export const safeAndScienctific = [
    {
        image: 'https://innovist.com/cdn/shop/files/icon-1_135edfb2-fb8c-4f2d-942b-cafa188d7081.png?v=1696846355',
        description: 'No Sulphates',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/icon-2_ed5d2407-58ab-491f-918a-79589b01ae34.png?v=1696846355',

        description: 'No Parabens',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/icon-3_c0ba8439-0d94-4f8f-8a80-21ea05173f3c.png?v=1696846355',

        description: 'No Phthalates',
    },
    {
        image: 'https://innovist.com/cdn/shop/files/icon-4.png?v=1696846355',

        description: 'Cruelty Free',
    },
    // {
    //     image: 'https://innovist.com/cdn/shop/files/icon-5.png?v=1696846355',
    //     description: 'Vegan',
    // },
    {
        image: 'https://innovist.com/cdn/shop/files/icon-6.png?v=1696846355',
        description: 'Derma tested',
    },

]
export const testimonials = [
    {
        bgimge: LOCAL_IMAGES.women2,
        para: "I'll be honest I never thought a shampoo system could have the results that i needed. My hair is definitely smoother on blowdrying but the magic happens when I straighten it. I have highlighted thick hair and as someone who needs to straighten it almost daily this has been a game changer.",
        name: 'kanchan pawar'


    },
    //    {
    //     bgimge:LOCAL_IMAGES.women2,
    //     para:"I love Argatin! My hair usually doesn't do well with gels, however, with the Argatin Keratin Repair Lasting Shampoo and Smooth Hair Mask my hair feels moisturized and defined. I love this combo. My hair just loves the combination and I can ensure you a long lasting result!",
    //     name:'Miss Gargee Nandi'

    //    },
    {
        bgimge: LOCAL_IMAGES.women3,
        para: "I have naturally curly hair, I’ve always straightened it due to how frizzy and uncontrollable it was. After using Argatin Hair Mask and Shampoo my hair has made a drastic change. My curls are more defined and healthy! I fell I love with this product. I fully recommend it to blinds and even curly brunettes!",
        name: 'Farzana Ahmed'

    },
    {
        bgimge: LOCAL_IMAGES.women4,
        para: "I love Argatin! My hair usually doesn't do well with gels, however, with the Argatin Keratin Repair Lasting Shampoo and Smooth Hair Mask my hair feels moisturized and defined. I love this combo. My hair just loves the combination and I can ensure you a long lasting result!",
        name: 'Priyanka Prakash'

    },

    {
        bgimge: LOCAL_IMAGES.women5,
        para: "As someone who's always struggled with hair color, I was nervous about trying something new. But Smart Salon team of experts put me at ease. My hair has never looked so beautiful and vibrant!",
        name: 'Arpita Singh'

    },


]

export const loveusData = [
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/Consumer-300x150.png'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/Halal-PNG-300x150.png'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/Peraben-Free1-300x150.png'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/lab-tested1-300x150.png'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/Cruelty-Free-300x150.webp'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/vegan-logo-300x150.png'
    },
    {
        image: 'https://argatinkeratin.com/wp-content/uploads/2022/11/dermatologically-tested-300x150.webp'
    },




]
export const termConditionData = [
    {
        question: 'SECTION 1 - ONLINE STORE TERMS',
        ans: 'By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).You must not transmit any worms or viruses or any code of a destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your Services. '
    },
    {
        question: 'SECTION 2 - GENERAL CONDITIONS',
        ans: 'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.  You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us. The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms. '
    },
    {
        question: 'SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION',
        ans: 'We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site. '
    },
    {
        question: 'SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES',
        ans: 'Prices for our products are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service. '
    },
    {
        question: 'SECTION 5 - PRODUCTS OR SERVICES',
        ans: "Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange only according to our Return Policy. We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.  We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or service made on this site is void where prohibited  We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected."
    },
    {
        question: 'SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION',
        ans: "We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors.  You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed.   For more detail, please review our Returns Policy.  "
    },
    {
        question: 'SECTION 7 - OPTIONAL TOOLS',
        ans: "We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.   You acknowledge and agree that we provide access to such tools ”as is” and “as available” without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools. Any use by you of optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s).  We may also, in the future, offer new services and/or features through the website (including, the release of new tools and resources). Such new features and/or services shall also be subject to these Terms of Service."
    },
    {
        question: 'SECTION 8 - THIRD-PARTY LINKS',
        ans: " Certain content, products and services available via our Service may include materials from third-parties. Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or services of third-parties.  We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party. "
    },
    {
        question: 'SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS',
        ans: "If, at our request, you send certain specific submissions (for example contest entries) or without a request from us you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.  We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party’s intellectual property or these Terms of Service. You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e-mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party. "
    },
    {
        question: 'SECTION 10 - PERSONAL INFORMATION',
        ans: 'Your submission of personal information through the store is governed by our Privacy Policy. '
    },
    {
        question: 'SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS',
        ans: 'Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).  We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated. '
    },
    {
        question: ' SECTION 12 - PROHIBITED USES',
        ans: 'In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses. '
    },
    {
        question: 'SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY',
        ans: "We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or error-free.  We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.  You agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you. You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.  In no case shall the professionalworld, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law."
    },
    {
        question: 'SECTION 14 - INDEMNIFICATION',
        ans: "You agree to indemnify, defend and hold harmless the professional and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party."
    },
    {
        question: 'SECTION 15 - SEVERABILITY',
        ans: 'In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.'
    },
    {
        question: 'SECTION 16 - TERMINATION',
        ans: "The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site. If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof). "
    },
    {
        question: 'SECTION 17 - ENTIRE AGREEMENT ',
        ans: "The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.  These Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service). Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party. "
    },
    {
        question: ' SECTION 18 - GOVERNING LAW',
        ans: 'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of India and jurisdiction of Jaipur, Rajasthan '
    },
    {
        question: ' SECTION 19 - CHANGES TO TERMS OF SERVICE',
        ans: 'You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.'
    },
    {
        question: 'SECTION 20 - CONTACT INFORMATION',
        ans: 'Questions about the Terms of Service should be sent to us at enquiry@theprofessionalworld.com'
    },


]
export const LorealData=[
    {
        img:"https://res.cloudinary.com/dkvmvyvnx/image/upload/v1704779528/Artboard_2_eiagji.png"
    },
    {
        img:"https://res.cloudinary.com/dkvmvyvnx/image/upload/v1704779386/Artboard_1_ajjvyf.png"
    }, 
    {
        img:"https://res.cloudinary.com/dkvmvyvnx/image/upload/v1704781867/Artboard_3_sfri8c.png"
    },
]
export   const rotateData = [
    {
      image:LOCAL_IMAGES.lorealoil,
      
      description: 'Loreal oil',
    },
    {
        image:LOCAL_IMAGES.lorealmask,

        description: 'Hair Mask',
      },
      {
        image:LOCAL_IMAGES.lorealconditioner,
      
        description: 'Loreal conditioner',
      },
      {
        image:LOCAL_IMAGES.lorealshampoo,
        description: 'Loreal Shampoo',
      },
    // {
    //   image: LOCAL_IMAGES.loreal2,

    //   description: 'Hair Conditioner',
    // },
    // {
    //   image: LOCAL_IMAGES.loreal3,

    //   description: 'Hair Oil',
    // },
    // {
    //   image: LOCAL_IMAGES.loreal4,

    //   description: 'Argatin keratin Treatment',
    // },

  ];
  export   const argatinroledData = [
    {
      image:
        LOCAL_IMAGES.argatinbrand1,
      description: 'Argatin Shampoo',
    },
    {
      image: LOCAL_IMAGES.argatinbrand2,

      description: 'Hair Conditioner',
    },
    {
      image: LOCAL_IMAGES.argatinbrand3,

      description: 'Hair Oil',
    },
    {
      image: LOCAL_IMAGES.argatinbrand4,

      description: 'Argatin keratin Treatment',
    },

  ];









  